import { WebSocketSymbolsActions } from '@app/+shared-state/real-time-data/ws-symbol.actions';

const excludedVerboseActions: string[] = [WebSocketSymbolsActions.updateRealTimeFieldsForSymbol.type];

export default excludedVerboseActions;
